import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Email = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Email_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 17,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 14 2.08 14 3.2 14h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 12.48 16 11.92 16 10.8V5.2c0-.43 0-.777-.012-1.067-.015-.348-.048-.611-.12-.832a1.434 1.434 0 0 0-.086-.209 2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C.097 3.33.043 3.608.019 4c.023-.367.071-.635.177-.863C0 3.56 0 4.117 0 5.194V10.8ZM12.8 3H3.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422-.019.226-.023.51-.024.908l5.65 4.237c.8.6 1.9.6 2.7 0L15 4.875c-.001-.398-.005-.681-.024-.907-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C13.75 3 13.377 3 12.8 3Zm2.2 7.8V6.124L9.95 9.912a3.25 3.25 0 0 1-3.9 0L1 6.127V10.8c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C2.25 13 2.623 13 3.2 13h9.6c.577 0 .949 0 1.232-.024.272-.022.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C15 11.75 15 11.377 15 10.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Email_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Email;